import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    withoutHover: {
      height: 20,
      '&:hover': {
        background: 'transparent',
      },

      '& th.MuiTableCell-root': {
        padding: '0px 16px',
        lineHeight: 1,
      },

      '& .MuiTypography-root': {
        fontSize: 12,
      },
    },
    fillTable: {
      '& th.MuiTableCell-root': {
        padding: '0px 16px',
        lineHeight: 1,
      },

      '& .MuiTypography-root': {
        fontSize: 12,
      },
    },
    row: {
      height: 20,

      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
        cursor: 'default',
      },

      '& td.MuiTableCell-root': {
        padding: '0px 16px',
        lineHeight: 1,
      },
    },
    cellCenter: {
      textAlign: 'center',
      fontSize: 12,
      color: palette.darkGray,

      '&:first-child': {
        paddingLeft: 30,
      },

      '&:last-child': {
        paddingLeft: 30,
      },
    },
    cell: {
      fontSize: 12,
      color: palette.darkGray,

      '&:first-child': {
        paddingLeft: 30,
      },

      '&:last-child': {
        paddingLeft: 30,
      },
    },
    cellContent: {
      display: 'flex',
      alignItems: 'center',
      color: palette.darkGray,
      '& .MuiOutlinedInput-root': {
        height: 25,
        borderColor: palette.blue,
        width: 90,
      },
      '& .MuiOutlinedInput-input': { height: 25, width: 90 },
      '& .MuiOutlinedInput-adornedEnd': { paddingRight: 2 },
    },

    cellMarked: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 800,
    },

    alignCenterSpan: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },

    orderIcon: {
      fontSize: 16,
      marginLeft: 4,
      cursor: 'pointer',
      opacity: 0.7,
    },

    orderIconMarked: {
      fontSize: 16,
      marginLeft: 4,
      cursor: 'pointer',
      opacity: 1,
    },

    rowLoadingCircular: {
      marginRight: 4,
    },

    iconSuccess: {
      color: palette.status.success,
      fontSize: 15,
    },
    iconBlocked: {
      color: palette.status.error,
      fontSize: 15,
    },

    moreButton: {
      padding: 0,
      '&:hover': {
        background: 'transparent',
      },
    },

    actionItem: {
      fontSize: 12,
      color: palette.darkGray,
    },

    pagination: {
      '& .MuiTablePagination-caption': {
        fontSize: 12,
      },

      '& .MuiTablePagination-select': {
        border: `1px solid ${palette.darkGray}`,
        textAlignLast: 'left',
        borderRadius: 5,
        fontSize: 12,
      },
    },

    alert: {
      maxWidth: 500,
      width: 'fit-content',
      margin: '0 auto',
      fontSize: 12,

      '& b': {
        fontWeight: 900,
      },
    },

    pointer: {
      cursor: 'pointer',
    },
    moreButtonIcon: { width: 16, height: 16 },
    isFixed: {
      height: '100%',
    },
    doneIcon: {
      fontSize: 18,
      color: palette.green,
      fontWeight: 'bold',
      marginRight: 1,
      cursor: 'pointer',
    },
    editIcon: { fontSize: 14, marginRight: 4, cursor: 'pointer' },
    loadingText: {
      width: '100%',
      animation: 'makeStyles-keyframes-loading-731 1s ease-in-out infinite',
      background:
        'linear-gradient(100deg, rgba(255, 255, 255, 0) 40%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 60%) #ededed',
      minHeight: '0.4rem',
      borderRadius: 4,
      marginBottom: 2,
      backgroundSize: '200% 100%',
      backgroundColor: '#ededed',
      backgroundPositionX: '180%',
      height: 8,
      margin: 0,
    },
    '@keyframes loading': {
      to: {
        backgroundPositionX: '-20%',
      },
    },
  });
